module.exports = __webpack_public_path__ + "static/media/course.9e39c7f6.svg";